import { render, staticRenderFns } from "./SynchronizeRanks.vue?vue&type=template&id=70df8474&scoped=true"
import script from "./SynchronizeRanks.vue?vue&type=script&lang=js"
export * from "./SynchronizeRanks.vue?vue&type=script&lang=js"
import style0 from "./SynchronizeRanks.vue?vue&type=style&index=0&id=70df8474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df8474",
  null
  
)

export default component.exports